<template>
    <div>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("cierreCaja")}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="listBusiness">{{$t("negocio")}}</label>
                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')"
                                           @change="getCierreCaja()">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaInicio")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        format="dd-MM-yyyy"
                                        :title="$t('fechaInicio')"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="datefrom"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaFin")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        :title="$t('fechaFin')"
                                        format="dd-MM-yyyy"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="dateto"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <label>&nbsp;</label>
                            <div class="form-group">
                                <button class="btn btn-primary" @click="getCierreCaja()"><i
                                        class="fa fa-refresh" v-if="loading"></i>
                                    {{$t("consultar")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <div class="col-md-12" v-else>
                <div class="card">
                    <template v-if="dateInform.length > 0">
                        <div class="row justify-content-between div-export">

                            <div class="col-md-12  text-left">
                                <el-dropdown>
                                    <el-button type="primary" size="small">
                                        <i class="fa fa-file"></i>
                                        {{$t("exportarInforme")}} <i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <a :href="urlExportPDF">
                                            <el-dropdown-item class="text-danger">
                                                <strong><i class="fa fa-file-pdf"></i> {{$t("exportarPdf")}}</strong>
                                            </el-dropdown-item>
                                        </a>
                                        <a :href="urlExportExcel">
                                            <el-dropdown-item class="text-success">
                                                <strong><i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}</strong>
                                            </el-dropdown-item>
                                        </a>
                                    </el-dropdown-menu>
                                </el-dropdown>

                            </div>
                        </div>

                        <div class="table-responsive" style="overflow: auto">
                            <table class="table table-bordered table-striped ">
                                <thead class="thead-dark">
                                <tr>
                                    <th>{{$t("fecha")}}</th>
                                    <th>{{$t("fechaCierre")}}</th>
                                    <th>{{$t("venta")}}</th>
                                    <th>{{$t("descuadre")}}</th>
                                    <th>{{$t("totalRecaudado")}}</th>
                                    <th>{{$t("acciones")}}</th>

                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(det,index) in dateInform">
                                    <td><span :class="getClassDay(det.date)">{{det.date | getDia}}
                                    {{det.date | parseDate}}</span></td>
                                    <td v-if="det.endDate!=='0'">{{det.endDate | parseDate}}</td>
                                    <td v-else></td>

                                    <td align="right">{{det.money+det.cards+det.checks | currency}}</td>
                                    <td align="right" v-if="det.countAmount>0">
                                        {{det.countAmount-(det.money+det.cards+det.checks-det.cashExpenses+det.changeNextDay)
                                        | currency}}
                                    </td>
                                    <td align="right" v-else>{{0 | currency}}</td>
                                    <td align="right" v-if="det.countAmount!==0">{{det.countAmount - det.changeNextDay
                                        |currency}}
                                    </td>
                                    <td v-else align="right">{{0 | currency}}</td>
                                    <td align="center"><i @click="openModal(index)" v-tooltip.top-center="$t('Desglose')"
                                                          class="fa fa-info-circle"></i></td>
                                </tr>


                                </tbody>
                                <tfoot>
                                <tr>
                                </tr>
                                </tfoot>
                            </table>
                        </div>

                    </template>
                    <template v-else>

                        <div class="alert alert-danger" role="alert">
                            {{$t("noHyaCierresDeCajaEnEsteRangoDeFecha")}}
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <modal name="desgloseModal" :adaptive=true :scrollable=true height="auto" :clickToClose=false>
            <div>
                <div v-if="dateInform.length>0" class="modal-header">
                    <h3>{{$t("cierreCajaZ")}} - {{dateInform[index].date | parseDateMin}}</h3>
                </div>
                <div v-if="dateInform.length>0" class="modal-body">
                    <p>{{$t("n")}} {{dateInform[index].idCode}}</p>
                    <p>{{$t("operario")}}: {{dateInform[index].nameWorker}}</p>
                    <p>{{$t("apertura")}}: {{dateInform[index].initDate |parseDateMin}}</p>
                    <p>{{$t("cierre")}}: <span v-if="dateInform[index].endDate!=='0'">{{dateInform[index].endDate|parseDateMin}}</span><span
                            v-else></span></p>
                    <p style='border-top:1px dashed black; height:2px'>&nbsp;</p>
                    <h4 style='margin-bottom:25px'>{{$t("totalVenta")}}:
                        {{dateInform[index].money+dateInform[index].cards+dateInform[index].checks |currency}}</h4>
                    <p>{{$t("efectivo")}}: {{dateInform[index].money | currency}}</p>
                    <p>{{$t("tarjetaCheques")}}: {{dateInform[index].cards +dateInform[index].checks |currency}}</p>
                    <p>{{$t("cambio")}}: {{dateInform[index].cashChange | currency}}</p>
                    <p>{{$t("gastos")}}: {{dateInform[index].cashExpenses |currency}}</p>
                    <p style='border-top:1px dashed black; height:2px'>&nbsp;</p>
                    <p>{{$t("totalTeorico")}}:
                        {{dateInform[index].money+dateInform[index].cards+dateInform[index].checks-dateInform[index].cashExpenses+
                        dateInform[index].cashChange |currency}}</p>
                    <p>{{$t("totalEnArqueo")}}: - {{dateInform[index].countAmount |currency}}</p>
                    <p style='border-top:1px dashed black; height:2px'>&nbsp;</p>
                    <h4 v-if="dateInform[index].countAmount>0" style='margin-bottom:25px'>{{$t("descuadre")}}:
                        {{dateInform[index].countAmount-(dateInform[index].money+dateInform[index].cards+dateInform[index].checks-dateInform[index].cashExpenses+dateInform[index].cashChange)
                        |currency}}</h4>
                    <h4 v-else style='margin-bottom:25px'>{{$t("descuadre")}}: {{0 | currency}}</h4>
                    <p>{{$t("totalEnArqueo")}}: {{dateInform[index].countAmount |currency}}</p>
                    <p>{{$t("cambioSig")}}. : {{dateInform[index].changeNextDat |currency}}</p>
                    <p style='border-top:1px dashed black; height:2px'>&nbsp;</p>
                    <h4 v-if="dateInform[index].countAmount>0" style='margin-bottom:25px'>{{$t("totalRecaudado")}}:
                        {{dateInform[index].countAmount-dateInform[index].changeNextDay |currency}}</h4>
                    <h4 v-else style='margin-bottom:25px'>{{$t("totalRecaudado")}}: {{0 | currency}}</h4>


                </div>
                <div v-if="dateInform.length>0" class="modal-footer">
                    <button class="btn btn-default" @click="cerrarModal()"><i class="fa fa-times-circle"></i>
                        {{$t("volver")}}
                    </button>

                </div>
            </div>
        </modal>


    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button} from 'element-ui'
    import swal from 'sweetalert2'
    import moment from 'moment'
    import { mapState } from 'vuex'

    export default {
        created() {
            this.loading = true;
            this.$store.dispatch("setNameRoute", this.$i18n.t("cierreCaja"));
            this.getBusiness();




            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
                this.value4[0] = this.$store.getters.dateFrom;
                this.value4[1] = this.$store.getters.dateTo;

            }
        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option
        },
        data() {
            return {
                loading: false,
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                dateto: new Date().toISOString(),
                listBusinesses: [],
                value4: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
                idBusiness: 0,
                data: [''],
                listTpv: [],
                cuentasAparcadas: false,
                dateInform: [],
                index: 0
            }
        },
        computed: {
            ...mapState(["permiso"]),
            urlExportPDF() {
                return this.$store.getters.apiUrl+"/sales/exportCierreCaja/PDF?idBusiness=" + this.idBusiness + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
            },
            urlExportExcel() {
                return this.$store.getters.apiUrl+"/sales/exportCierreCaja/Excel?idBusiness=" + this.idBusiness + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
            },

            getTotal() {
                let total = 0;
                this.dateInform.forEach(function (d) {
                    total += d.amount;
                });
                return total;
            },
        },
        methods: {

            getTotalImpuesto(index) {
                let total = 0;
                this.dateInform[index].headers.forEach(function (d) {


                    total += d.amount;

                });
                return total;
            },
            getBusiness() {
                var config = {
                    params:{
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {
                        vm.listBusinesses = response.data.result;


                        if (vm.$store.getters.idBusiness) {
                            vm.idBusiness = vm.$store.getters.idBusiness;
                        }
                        else{

                            vm.idBusiness = response.data.result[0].id;
                        }


                        vm.getCierreCaja();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            openModal(indice) {

                this.index = indice;

                this.$modal.show('desgloseModal');


            },

            cerrarModal() {

                this.indice = 0;
                this.index = 0;

                this.$modal.hide('desgloseModal');
            },

            getCierreCaja() {


                if (this.datefrom === null || this.dateto === null) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                } else {

                    let secondsDesde = moment(this.datefrom).unix();
                    let secondsHasta = moment(this.dateto).unix();

                    if (secondsHasta < secondsDesde) {
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    } else {
                        this.$store.dispatch("setDateTo", this.dateto);
                        this.$store.dispatch("setDateFrom", this.datefrom);

                        this.loading = true;


                        var config = {
                            params: {
                                idBusiness: this.idBusiness,
                                datefrom: moment(this.datefrom).startOf("day").unix(),
                                dateto: moment(this.dateto).endOf("day").unix(),
                                jwt: this.$store.getters.jwt
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };

                        let vm = this;
                        this.$store.dispatch("setIdBusiness", this.idBusiness);
                        this.axios.get(this.$store.getters.apiUrl + "sales/getCierreCaja", config)
                            .then(function (response) {
                                if (response.data.response) {

                                    vm.dateInform = response.data.result;

                                }
                                else {

                                    swal({
                                        title: vm.$t('atencion'),
                                        text: response.data.message,
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        type: 'error'
                                    });

                                }
                                vm.loading = false;

                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                }

            },
            getClassDay(date) {
                var classDay = "";
                var humanDate = moment.unix(date);
                var dia = moment(humanDate).format("d");

                if (dia === "0") {
                    classDay = "sunday";
                } else if (dia == 5 || dia == 6) {
                    classDay = "fridaySaturday";
                }

                return classDay;
            }
        }
    }
</script>

<style scoped>

    a li {
        color: #111;
    }

    .card {
        padding: 20px;
    }

    .div-export {
        margin-bottom: 10px;
    }

</style>




// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Ventas/CierresCaja.vue